const parsers = {};
export function add(parser, ...contentType) {
    contentType.forEach(t => (parsers[t] = parser));
}
export function parse(request) {
    const contentType = request.headers.get("Content-Type");
    const type = contentType && contentType.split(";");
    const parser = parsers[type?.[0] ?? "plain/text"];
    return parser ? parser(request) : request.text();
}
//# sourceMappingURL=Parser.js.map